<template>
  <div>
    <div class=" mainLoader" v-if="loading"> </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p id="title" class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('ep_title')}}</p>
              <p id="desc" class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('ep_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img id="man" src="../../assets/imgs/singin_man.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-e-engineer-sidenav v-if="profileLoaded" :selectedItem="selectedItem"></app-e-engineer-sidenav>
          </div>
          <div class="col-md-9">
            <div class="container" >
              <div class="row" v-show="company_show_flag === 'false'">
                <div id="warnning" class="col-sm-12 alert alert-warning">
                  現在、エンジニアの方の先行登録のみを受け付けておりますので、企業情報は表示されておりません。<br />
                  企業情報が公開されたタイミングでメールにてお知らせいたしますので、今しばらくお待ちください。
                </div>
              </div>
            </div>
            <div class="container" >
              <div class="row d-none" :class="{ 'd-block': !engineer_mail_verified , 'd-none' : engineer_mail_verified }">
                <div v-if="engineer_new_email !=''" >
                  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      {{$t('ep_email_verify_text')}} &nbsp;&nbsp; <br><strong> <span class="resend-link" @click="resendMail()">{{$t('ep_email_link')}}</span></strong>
                    <div class="close" data-dismiss="alert" @click="cancelChangingEmail()" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                   <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      {{$t('ep_email_verify_text')}} &nbsp;&nbsp; <br>
                      <strong> <span class="resend-link" @click="sendVerificationLink()">{{$t('ep_email_link')}}</span></strong>
                   </div>
                </div>
              </div>
            </div>
            <div class="container mt-2" :class="{ 'd-block': !engineer_completed_interview , 'd-none' : engineer_completed_interview }">
              <div  class="row">
                <div class="col-sm-10 alert alert-warning">
                 {{$t('ep_interview_completion_text')}}<br />
                 {{$t('ep_interview_completion_text2')}}
                </div>
                <div class="col-sm-2 mt-3">
                  <router-link to="/global/contact-inqury">
                    <button class="btn btn-success">{{$t('ep_interview_completion_button')}}</button>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('ep_page')}}</span>
            </div>
            <div class="row slide_options">
              <div class="col-md-6 slide_item spressed wrapper1 " id="s1" @click="pressed_slide(1)">
                <span class="slide_txt mplus2p-r spacing1-4">{{$t('e_profile')}}</span>
              </div>
              <div class="col-md-6 slide_item wrapper1" id="s2" @click="pressed_slide(2)">
                <span class="slide_txt mplus2p-r spacing1-4">{{$t('e_score')}}</span>
              </div>
            </div>

            <div class="container">
              <div class="row pview " id="basic_info">
                <div v-if="!facebook_enable" class="col-md-12 text-right">
                  <fb-signin-button :params="fbSignInParams" @success="onSignInSuccess" @error="onSignInError">
                    <svg aria-hidden="true" class="svg-icon iconFacebook" width="24" height="24" viewBox="0 0 16 18">
                      <path d="M1.88 1C1.4 1 1 1.4 1 1.88v14.24c0 .48.4.88.88.88h7.67v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h4.08c.48 0 .88-.4.88-.88V1.88c0-.48-.4-.88-.88-.88H1.88z" fill="#fff"></path>
                    </svg>
                    <span> {{$t('facebook_enable')}}</span>
                  </fb-signin-button>
                </div>
                <div v-else class="col-md-12 text-right">
                  <button class="btn fb-signin-button-disable" disabled>
                    <svg aria-hidden="true" class="svg-icon iconFacebook" width="24" height="24" viewBox="0 0 16 18">
                      <path d="M1.88 1C1.4 1 1 1.4 1 1.88v14.24c0 .48.4.88.88.88h7.67v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h4.08c.48 0 .88-.4.88-.88V1.88c0-.48-.4-.88-.88-.88H1.88z" fill="#fff"></path>
                    </svg>
                    <span> {{$t('facebook_connected')}}</span>
                  </button>
                </div>
                <template style="margin-bottom:90px">
                  <div class="col-md-3 text-center">
                     <video v-if="engineer_video"   height="150" width="150" controls autoplay loop>
                          <source :src="engineer_video">
                      </video>

                    <img v-if="engineer_image" class="rounded-circle1" style="width: 150px; height:150px;" :src="engineer_image" />
                  </div>
                  <div class="col-md-9">
                    <div class="row" style="margin-top: 2rem">
                      <div class="col-md-4">
                        <label class="pgraytxt mplus2p-m spacing1-2 noiseblack pl-0">{{$t('r_lastname')}}:</label>
                        <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_lastname}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="pgraytxt mplus2p-m spacing1-2 noiseblack pl-0">{{$t('r_firstname')}}:</label>
                        <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_firstname}}</p>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 2rem">
                      <div class="col-md-4">
                        <label class="pgraytxt mplus2p-m spacing1-2 noiseblack pl-0">{{$t('r_lastname_phonetic')}}:</label>
                        <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_lastname_phonetic}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="pgraytxt mplus2p-m spacing1-2 noiseblack pl-0">{{$t('r_firstname_phonetic')}}:</label>
                        <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_firstname_phonetic}}</p>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="engineer_initials">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('r_initials')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_initials}}</p>
                  </div>
                </template>

                <div class="col-md-12" style="height: 30px;"></div>
                <template v-if="enginner_job_seeking">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_job_seeking')}}</p>
                  </div>
                  <div v-if="enginner_job_seeking != null " class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{enginner_job_seeking.en_situation}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{enginner_job_seeking.jp_situation}}</p>
                  </div>
                </template>

                <template v-if="engineer_expertise">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t(' expertise ')}}</p>
                  </div>
                  <div v-if="engineer_expertise != null " class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_expertise.en_expertise}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_expertise.jp_expertise}}</p>
                  </div>
                </template>

                <template v-if="engineer_desc">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack" style="margin-top: 17.5px;">
                      {{$t('ep_basic_info')}}</p>
                  </div>
                  <div class="col-md-8">
                    <pre class="cs_summary mplus2p-m spacing1-2 noiseblack" style="height:auto;white-space:pre-wrap;" v-html='urlify(engineer_desc)'></pre>
                  </div>
                </template>
                <!-- <template class="col-md-12" v-if="engineer_nickname">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('r_nickname')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_nickname}}</p>
                  </div>
                </template> -->

                <template v-if="engineer_email">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('r_email')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_email}}<button class="clickcbtn bluebtn" @click="openDilog" style="margin-right: 10px;">
                        <i class="fa fa-pencil margin-r-5"></i>
                      </button></p>
                  </div>
                </template>

                <template v-if="engineer_bday">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_bday')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_bday}}</p>
                  </div>
                </template>

                <template v-if="engineer_sex">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_sex')}}</p>
                  </div>
                  <div v-if="engineer_sex != ''" class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_sex.en_gender}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_sex.jp_gender}}</p>
                  </div>
                </template>

                <template v-if="engineer_location">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_location')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_location.en_location}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_location.jp_location}}</p>
                  </div>
                </template>

                <template v-if="engineer_national">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_national')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p v-if="lan == 'en'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_national.en_national}}</p>
                    <p v-if="lan == 'jp'" class="mplus2p-m spacing1-2 noiseblack">{{engineer_national.jp_national}}</p>
                  </div>

                </template>

                <template v-if="Array.isArray(engineer_languages) && engineer_languages.length > 0">

                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_languages')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_languages" :key="index">{{ lan == 'en'? item.en_language:item.jp_language}}</span>
                    </div>
                  </div>
                </template>

                <template v-if="engineer_required_position.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_required_position')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_required_position" :key="index">{{ lan == 'en'? item.en_required_position:item.jp_required_position}}</span>
                    </div>
                  </div>
                </template>

                <template v-if="Array.isArray(engineer_requried_type_of_contract) && engineer_requried_type_of_contract.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">
                      {{$t('ep_requried_type_of_contract')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_requried_type_of_contract" :key="index">{{ lan == 'en'? item.en_required_type:item.jp_required_type}}</span>
                    </div>
                  </div>
                </template>

                <template v-if="Array.isArray(engineer_required_work_area_to_be) && engineer_required_work_area_to_be.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">
                      {{$t('ep_required_work_area_to_be')}}</p>
                  </div>
                  <div class="col-md-8">
                    <div class="tech2">
                      <span class="layer2" v-for="(item, index) of engineer_required_work_area_to_be" :key="index">{{ lan == 'en'? item.en_work_area:item.jp_work_area}}</span>
                    </div>
                  </div>
                </template>
                 <template v-if="engineer_income_type && engineer_income != 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_desired')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{lan == 'en' ? engineer_income_type.en_type : engineer_income_type.jp_type}} <b>{{engineer_income}}</b> {{$t('ep_currency_unit')}}</p>
                  </div>
                </template>

                <template v-if="engineer_policy">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_policy')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">{{engineer_policy}}</p>
                  </div>
                </template>

                <template v-if="engineer_experience">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_experience')}}</p>
                  </div>
                  <div class="col-md-8">
                    <p class="mplus2p-m spacing1-2 noiseblack">
                      {{lan == 'en' ? engineer_experience.en_experience : engineer_experience.jp_experience}}
                    </p>
                  </div>
                </template>

                <template v-if="engineer_current_position">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_current_position')}}</p>
                  </div>
                  <div class="col-md-8">

                    <p class="mplus2p-m spacing1-2 noiseblack">
                      {{lan == 'en' ? engineer_current_position.en_required_position : engineer_current_position.jp_required_position}}</p>
                  </div>
                </template>

                <template v-if="engineer_current_type_of_contract != null">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-4">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">
                      {{$t('ep_current_type_of_contract')}}</p>
                  </div>
                  <div class="col-md-8">

                    <p class="mplus2p-m spacing1-2 noiseblack">
                      {{lan == 'en' ? engineer_current_type_of_contract.en_required_type : engineer_current_type_of_contract.jp_required_type}}</p>
                  </div>
                </template>

                <template v-if="engineer_past_job_details.length > 0">
                  <div class="col-md-12" style="height: 15px;"></div>
                  <div class="col-md-12">
                    <p class="pgraytxt mplus2p-m spacing1-2 noiseblack">{{$t('ep_past_job_details')}}</p>
                    <div class="job-main" v-for="(item, index) in engineer_past_job_details" :key="index">
                        <div class="jobDetail">
                          <div class="row">
                          <div class="col-md-12 pt-2  mb-2" style="padding-left:15px">
                             <p  style="text-transform: capitalize" class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{item.experienced_corporate ? lan == 'en' ? item.experienced_corporate.en_corporate : item.experienced_corporate.jp_corporate : ''}}</p>
                             <p  style="text-decoration:underline;text-transform: capitalize" class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{item.position_overview ? item.position_overview : ''}}</p>
                          </div>
                          </div>
                        <div class="row">
                          <div class="col-md-2 pr-0" style="padding-left:15px">
                          <p class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{$t('past_job_period')}} </p>

                          </div>
                          <div class="col-md-10 pl-0">
                              <p class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack">{{item.started_at ? startDate(item.started_at) : ''}} ~ {{item.ended_at ? endDate(item.ended_at) : ''}}</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-2 pr-0" style="padding-left:15px">
                             <p  class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack ">{{$t('past_job_details')}}  </p>
                          </div>
                          <div class="col-md-10 pl-0">
                            <p  class="p-0 mb-1 mplus2p-m spacing1-2 noiseblack jobDetailDesc">{{item.responsibility}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="col-md-12 pv_btnpanel" v-if="userToken == loginUserToken">
                  <router-link :to="{ name: 'engineerProfileEdit', params: {uid: userToken} }">
                    <button class="btn bluebtn updatebtn">{{$t('ep_button')}}</button>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="row eview" id="score_info">
              <div v-if="!facebook_enable" class="col-md-12 text-right">
                  <fb-signin-button :params="fbSignInParams" @success="onSignInSuccess" @error="onSignInError">
                    <svg aria-hidden="true" class="svg-icon iconFacebook" width="24" height="24" viewBox="0 0 16 18">
                      <path d="M1.88 1C1.4 1 1 1.4 1 1.88v14.24c0 .48.4.88.88.88h7.67v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h4.08c.48 0 .88-.4.88-.88V1.88c0-.48-.4-.88-.88-.88H1.88z" fill="#fff"></path>
                    </svg>
                    <span> {{$t('facebook_enable')}}</span>
                  </fb-signin-button>
                </div>
                <div v-else class="col-md-12 text-right">
                  <button class="btn fb-signin-button-disable" disabled>
                    <svg aria-hidden="true" class="svg-icon iconFacebook" width="24" height="24" viewBox="0 0 16 18">
                      <path d="M1.88 1C1.4 1 1 1.4 1 1.88v14.24c0 .48.4.88.88.88h7.67v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h4.08c.48 0 .88-.4.88-.88V1.88c0-.48-.4-.88-.88-.88H1.88z" fill="#fff"></path>
                    </svg>
                    <span> {{$t('facebook_connected')}}</span>
                  </button>
                </div>
              <div class="col-md-12 pv_showchart">
                <div class="row">
                  <div class="col-md-4 text-center" style="border-right: 1px solid #e1e1e1;">
                    <p class="cocogothic spacing3-2  spacing3-2 noiseblack statustitle text-center">
                      {{$t('sk_total_lb')}}</p>
                    <div class="chartboxes">
                      <h3 class="mplus2p-r noiseblack statusnum" id="total">{{model.total}}</h3>

                    </div>
                  </div>
                  <div class="col-md-4 text-center" style="border-right: 1px solid #e1e1e1;">
                    <p class="cocogothic spacing3-2 noiseblack statustitle text-center">{{$t('sk_technical_lb')}}</p>
                    <div class="chartboxes">
                      <h3 class="mplus2p-r noiseblack statusnum" id="technical">{{model.technical}}</h3>

                    </div>
                  </div>
                  <div class="col-md-4 text-center">
                    <p class="cocogothic spacing3-2 noiseblack statustitle">{{$t('sk_management_lb')}}/{{$t('sk_business_lb')}}</p>
                    <div class="chartboxes">
                      <h3 class="mplus2p-r noiseblack statusnum" id="management">{{model.management}}</h3>

                    </div>
                  </div>
                </div>
              </div>

              <div class="row slide_options">
                <div class="col-md-6 slide_item spressed wrapper2" id="p1" @click="pressed_slide_skill(1)">
                  <span class="slide_txt mplus2p-r spacing1-4">{{$t('sk_technical_lb')}}</span>
                </div>
                <div class="col-md-6 slide_item wrapper2" id="p2" @click="pressed_slide_skill(2)">
                  <span class="slide_txt mplus2p-r spacing1-4">{{$t('sk_management_lb')}}/{{$t('sk_business_lb')}}</span>
                </div>
              </div>

              <div id="technical_info">
                <div class="col-md-12 text-right">

                  <div class="dropdown">
                    <a href="javascript:void(0)" class="nav-link blue" data-toggle="dropdown">
                      <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('about_defination')}}</span>
                    </a>
                    <div class="notification-container custom-popup dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                      <p class="text-center"><strong>{{$t('description_of_definitions')}} </strong><button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button></p>
                      <hr class="cline">
                      <div class="pl-3 pr-3 ">
                        <p><strong>{{$t('definition_of_choice')}}</strong></p>
                        <p><span class="text-danger">{{$t('no_experience')}}</span> {{$t('no_experience_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('experienced')}}</span> {{$t('experienced_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('no_confidence')}}</span> {{$t('no_confidence_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('confident')}}</span> {{$t('confident_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('very_confident')}}</span> {{$t('very_confident_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('know')}}</span> {{$t('know_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('implement')}}</span> {{$t('implement_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('set')}}</span> {{$t('set_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('build')}}</span> {{$t('build_desc')}}<span></span> </p>
                        <p><strong>{{$t('defination_intention')}}</strong></p>
                        <p><span class="text-danger">{{$t('occurred')}}</span> {{$t('occurred_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('catch_up_technique')}}</span> {{$t('catch_up_technique_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('choose_technique')}}</span> {{$t('choose_technique_desc')}}<span></span> </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 pv_showchart">
                  <div class="row">
                    <div class="col-md-12 skillUpdate">
                      <div class="skillUpdate row">
                        <div v-if="skills.length > 0" class="col-md-12">
                          <div v-for="(skill, index) in skills" :key="index">
                            <div class="border-3" v-for="(question, index) in skill.Technical" :key="index">
                              <div v-if="question.name">
                                <h2 v-if="question" class="" style="text-align:left">
                                  {{lan == 'en' ? question.name : question[0]}} </h2>
                                <div v-if="question.name" >
                                  <div class="tech2" v-for="(level, index) in question" :key="index">
                                    <span v-if="index != 0 && level.name" class="sub-layer2">{{lan == 'en' ? level.name : level.jp_name }}</span>
                                    <span class="layer2" v-if="index != 0 && level.answer">{{level.answer}}</span>
                                    <span class="layer2" v-for="(item, index) in level.skill" :key="index">{{lan == 'en' ? item.check_content : item.jp_check_content }}</span>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                        <div v-else class="col-md-12">
                          <div class="col-md-12 alert alert-danger text-center">
                            <strong>{{$t('err_skill_not_found')}}</strong>
                          </div>
                        </div>
                        <div v-if="skillLoader" class="d-block text-center w-100">
                          <i class="fa fa-spinner fa-4x fa-spin" style="color:#3d7dd8"></i>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div id="management_info">
                <div class="col-md-12 text-right">

                  <div class="dropdown">
                    <a href="javascript:void(0)" class="nav-link blue" data-toggle="dropdown">
                      <span class="addlinks mplus2p-m spacing1-2 blue">{{$t('about_defination')}}</span>
                    </a>
                    <div class="notification-container custom-popup dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                      <p class="text-center"><strong>{{$t('description_of_definitions')}}</strong> <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button></p>
                      <hr class="cline">
                      <div class="pl-3 pr-3 ">
                        <p><strong>{{$t('definition_of_skill')}}</strong></p>
                        <p><span class="text-danger">{{$t('pmo')}}</span> {{$t('pmo_desc')}}<span></span> </p>
                        <p><strong>{{$t('definition_of_choice')}}</strong></p>
                        <p><span class="text-danger">{{$t('have_knowledge')}}</span> {{$t('have_knowledge_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('pay_attention')}}</span> {{$t('pay_attention_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('have_know')}}</span> {{$t('have_know_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('management_experienced')}}</span> {{$t('management_experienced_desc')}}<span></span> </p>
                        <p><span>{{$t('in')}}</span><span class="text-danger">{{$t('in_desc1')}}</span> {{$t('in_desc2')}}<span></span> </p>
                        <p><strong>{{$t('what_i_want')}}</strong></p>
                        <p><span class="text-danger">{{$t('member_growing_up')}}</span> {{$t('member_growing_up_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('team_member')}}</span> {{$t('team_member_desc')}}<span></span> </p>
                        <p><span class="text-danger">{{$t('bussiness_will_taken')}}</span> {{$t('bussiness_will_taken_desc')}}<span></span> </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 pv_showchart">
                  <div class="row">
                    <div class="col-md-12 skillUpdate">
                      <div class="skillUpdate row">
                        <div v-if="skills != ''" class="col-md-12">
                          <div v-for="(skill, index) in skills" :key="index">
                            <div class="border-3" v-for="(question, index) in skill.Management" :key="index">
                              <div v-if="question.name">
                                <h2 class="" style="text-align:left">
                                  {{lan == 'en' ? question.name : question[0]}}</h2>
                                <div class="tech2" v-for="(level, index) in question" :key="index">
                                  <span v-if="index != 0 && level.name" class="sub-layer2">{{lan == 'en' ? level.name : level.jp_name}}</span>
                                  <span class="layer2" v-if="index != 0 && level.answer">{{level.answer}}</span>
                                  <span class="layer2" v-for="(item, index) in level.skill" :key="index">{{lan == 'en' ? item.check_content : item.jp_check_content }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="col-md-12">
                          <div class="col-md-12 alert alert-danger text-center">
                            <strong>{{$t('err_skill_not_found')}}</strong>
                          </div>
                        </div>
                        <div v-if="skillLoader" class="d-block text-center w-100">
                          <i class="fa fa-spinner fa-4x fa-spin" style="color:#3d7dd8"></i>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-4">
                <router-link to="/engineer/skill-update">
                  <button class="btn btn-outline-primary float-right">{{$t('sk_skill_update')}}</button>
                </router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="engineerProfileImage" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{$t('ep_change_email')}}</h5>
            <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button>
          </div>
          <div>
            <form role="form" @submit.prevent="doSandMail()">
              <div class="modal-body" style="text-align: center;">
                <input type="hidden" name="_token" value="">
                <div class="form-group input" :class="{ invalid: $v.email.$error && emailFocus }">
                  <div class="col-md-12">
                    <label style="float: left;" class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_email')}} <span style="color: red;">*</span></label>
                  </div>
                  <div class="col-md-12">
                    <input
                          placeholder="yourname@example.com"
                          type="email"
                          v-model="$v.email.$model"
                          class="peditboxes peditinput linput form-control"
                          name="policy"
                          autofocus />
                      <div class="help-block text-left" v-if="!$v.email.email">{{$t('r_c_email_validation')}}</div>
                      <div class="help-block text-left" v-if="!$v.email.req && emailFocus">{{$t('r_email_validation')}}</div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button id="updateEmail" type="submit" class='btn bluebtn DoneCrop'>{{$t('cp_edit_update')}} <i class="fa fa-spinner fa-spin" v-if="emailLoading" style="font-size:18px"></i></button>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
    <button type="button" class="d-none" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#engineerProfileImage" ref="myBtn">
      Launch demo modal
    </button>
    <button type="button" class="d-none" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-dismiss="modal" data-target="#engineerProfileImage" ref="closeModal"></button>
  </div>
</template>

<script>
  import {validationMixin} from "vuelidate";
  import {
    required,
    maxLength,
    email,
    minLength,
    sameAs
  } from "vuelidate/lib/validators";
import axios from "axios";
import e_engineer_sidenav from "./e_engineer_sidenav";
import { EventBus } from "../../main.js";

export default {
   mixins: [validationMixin],

    validations: {
      email: {req: required, email}
    },
  data() {
    return {
      fbSignInParams: {
        scope: "public_profile,email"
      },
      selectedItem: 1,
      loading: false,
      emailLoading: false,
      emailFocus: false,
      facebook_enable: '',
      email: "",
      model: "",
      userId: "",
      companyId: "",
      engineer_desc: "",
      engineer_firstname: "",
      engineer_lastname: "",
      engineer_lastname_phonetic: "",
      engineer_firstname_phonetic: "",
      engineer_initials: "",
      engineer_id: "",
      engineer_nickname: "",
      engineer_bday: "",
      engineer_sex: "",
      engineer_location: [],
      engineer_required_work_area_to_be: [],
      engineer_income_type: '',
      engineer_income: '',
      engineer_policy: "",
      engineer_email: "",
      engineer_new_email: '',
      engineer_image: "",
      engineer_video: "",
      engineer_experience: "",
      engineer_national: [],
      engineer_current_position: "",
      engineer_current_type_of_contract: [],
      engineer_required_position: "",
      engineer_requried_type_of_contract: [],
      engineer_languages: [],
      engineer_company_name: "",
      engineer_expertise: "",
      enginner_job_seeking: '',
      engineer_role_to_handle: '',
      engineer_completed_interview : true,
      engineer_mail_verified: true,
      engineer_past_job_details: [],

      panelid: 1,
      skillPanelid: 1,

      loginUserToken: "",
      userToken: "",

      skills: [],
      skillLoader: false,

      model: {},
      lan: "jp",
      company_show_flag: '',
      profileLoaded: false
    };
  },
  components: {
    appEEngineerSidenav: e_engineer_sidenav,
  },
  beforeMount(){
    if ("user" in localStorage) {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      // if (!data.nickname) {
      //  this.$router.replace("/engineer/nickname")
      // }
    }
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    if ("user" in localStorage) {
      var data = JSON.parse(localStorage.getItem("user"));
      this.userId = data.id;
      this.loginUserToken = data.user_token;
      this.facebook_enable = data.facebook_enable;
    }
    this.userToken = this.$route.params.uid;
    if (this.loginUserToken != this.userToken) {
      this.$router.push("/global/PageNotFound");
    }
    this.engineerProfile(this.userId);

    this.company_show_flag = process.env.VUE_APP_FLAG;
  },
  mounted() {
    this.doCenter();
    this.pressed_slide(this.panelid);
    this.pressed_slide_skill(this.skillPanelid);
    EventBus.$on("language", data => {
      this.lan = data;
    });
    EventBus.$on("fblogin",data => {
      this.facebook_enable = data;
    })

    $('#engineerProfileImage').on('hidden.bs.modal', () => {
        this.emailFocus = false;
        this.email = null;
        this.$v.$reset()
        // vm.email = "";
    })
  },
  computed: {
    onResize(event) {
      this.doCenter();
    },
  },
  methods: {
    sendVerificationLink() {
      this.loading = true;
      let data = {
        email: this.engineer_email
      }
      axios
      .post('verify-again', data,
        {
          headers: { "X-localization": localStorage.getItem("lan") }
        }
      )
      .then((res) => {
        if (!res.data.result) {
          for (var i = 0; i < res.data.errors.length; i++) {
            this.$toaster.error(res.data.errors[i].message);
            if (res.data.errors[i].field === "email") {
              this.$toaster.error(res.data.errors[i].message);
            }
          }
          this.loading = false;
        } else {
          this.$toaster.success(res.data.message);
          this.loading = false;
        }
      })
      .catch((error) => {
        // error
        this.loading = false;
      });
    },
    cancelChangingEmail(){
       let data = {
          email: this.engineer_new_email
        }
          axios
          .post('cancel-changing-email?token=' + localStorage.getItem("token") , data,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            }
          )
          .then((res) => {
          })
          .catch((error) => {
            console.log(error);
          });
    },
    resendMail(){
       let data = {
          email: this.engineer_new_email
        }
          axios
          .post('verify-email-again?token=' + localStorage.getItem("token") , data,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            }
          )
          .then((res) => {
            if (!res.data.result) {
              for (var i = 0; i < res.data.errors.length; i++) {
                if (res.data.errors[i].field === "User already verified.") {

                  this.$toaster.error(res.data.errors[i].message);
                }
                if (res.data.errors[i].field === "email") {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }

            } else {
              this.$toaster.success(res.data.message);
            }
          })
          .catch((error) => {
            // error
            this.loading = false;
          });
    },
     startDate(date){
      return moment(date).format('YYYY/MM')
    },
    endDate(date){
      return moment(date).format('YYYY/MM')
    },
    onSignInSuccess() {
      this.loading = true;
      var user = JSON.parse(localStorage.getItem("user"))
      var token = localStorage.getItem("token");
        FB.getLoginStatus((response) => {
        if (response.status === 'connected') {

          FB.api('/me?fields=first_name,last_name,email,picture', (response) => {
            const formData = {
              provider_id: response.id,
            }
            axios.post('/enable-facebook?token=' + token, formData,{
              headers: { "X-localization": localStorage.getItem("lan") }})
              .then(res => {
                  this.facebook_enable = res.data.facebook_enable;
                  user.facebook_enable = res.data.facebook_enable;
                  localStorage.setItem("user", JSON.stringify(user));
                  this.loading = false;
              })
              .catch(error => console.log(error))
          })
        }
      })

    },
    onSignInError(error) {
      console.log("OH NOES", error);
    },

    doSandMail() {
      this.emailLoading = true;
      var token = localStorage.getItem("token");
      const thisVue = this;
      const formData = {
        email: this.email
      };
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.emailFocus = true;
        this.emailLoading = false;
      } else {
         axios
        .post("/change-email?token=" + token, formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
                this.$toaster.error(res.data.errors[i].message);
              }
            }
            this.emailLoading = false;
          } else {
            this.emailLoading = false;
            this.engineerProfile(this.userId);
            this.$toaster.success(thisVue.$t("success_change_mail"));
            this.email = "";
            const elem = this.$refs.closeModal;
            elem.click();
          }
        })
        .catch(error => console.log(error));
      }

    },
    openDilog() {
      this.showModal();
    },
    showModal() {
      const elem = this.$refs.myBtn;
      elem.click();
    },
    getScore(skillPanalId) {
      this.skillLoader = true;
      axios
        .get("/user-skill-items?token=" + localStorage.getItem("token"))
        .then(res => {
          this.model.total = res.data.total;
          this.model.technical = res.data.technical_total;
          this.model.management = res.data.other_total;
          if (res.data.skills != null) {
            // var skills = res.data.skills.sort(function(a, b) {
            //   return a.id - b.id;
            // });

            this.skills = res.data.skills;
            if (skillPanalId == 1) {
              let arr = [];
              for (let item in this.skills[0].Technical) {
                let obj = this.skills[0].Technical[item];
                obj.name = item;
                arr.push(obj);
              }
              arr.sort((a, b) => {
                return a[1].subcategory_id - b[1].subcategory_id;
              });

              this.skills[0].Technical = arr;
            }
            if (skillPanalId == 2) {
              this.skills = res.data.skills;
              let arr2 = [];
              for (let item2 in this.skills[0].Management) {
                let obj = this.skills[0].Management[item2];
                obj.name = item2;
                arr2.push(obj);
              }
              arr2.sort((a, b) => {
                return a[1].subcategory_id - b[1].subcategory_id;
              });
              this.skills[0].Management = arr2;
            }
            this.skillLoader = false;
          }
        })
        .catch(error => {
          this.skillLoader = false;
        });
      this.$forceUpdate();
    },
    urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      //var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url,b,c) {
          var url2 = (c == 'www.') ?  'http://' +url : url;
          return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
      })
    },
    engineerProfile(id) {
      this.loading = true;
      axios
        .get("/user/" + id + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
             if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
                if (res.data.errors[i].message) {
                  this.$toaster.error(res.data.errors[i].message);
                  return  this.$store.dispatch("logout");
                }
              }
            }
            this.loading = false;
          } else {
            
            this.image = res.data.user.image;
            this.engineer_desc = res.data.user.career_summary;
            if (res.data.user.last_name) {
              this.engineer_lastname = res.data.user.last_name;
            }

            if (res.data.user.first_name) {
              this.engineer_firstname = res.data.user.first_name;
            }

            if (res.data.user.last_name_phonetic) {
              this.engineer_lastname_phonetic = res.data.user.last_name_phonetic;
            }

            if (res.data.user.first_name_phonetic) {
              this.engineer_firstname_phonetic = res.data.user.first_name_phonetic;
            }

            if (res.data.user.initials) {
              this.engineer_initials = res.data.user.initials;
            }

            this.engineer_id = res.data.user.id;
            this.engineer_nickname = res.data.user.nickname;
            this.engineer_email = res.data.user.email;
            if (res.data.user.new_email) {
              this.engineer_new_email = res.data.user.new_email;
            }
            if (res.data.user.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.engineer_video = res.data.user.image
            }else{
              this.engineer_image = res.data.user.image;
            }
            this.engineer_bday = res.data.user.birthdate;
            this.facebook_enable = res.data.user.facebook_enable;
            this.engineer_completed_interview = res.data.user.completed_interview;
            this.engineer_mail_verified = res.data.user.verified;
            try {
              this.engineer_sex = res.data.user.gender
                ? res.data.user.gender
                : "";
              this.engineer_location = res.data.user.location;
              this.engineer_income_type = res.data.user.income_type_id;

              this.engineer_income = res.data.user.income.toLocaleString();
              this.engineer_policy = res.data.user.policy;
              this.engineer_experience = res.data.user.experience;
              this.engineer_national = res.data.user.national;
              this.engineer_current_position = res.data.user.current_position;
              this.engineer_expertise = res.data.user.expertise;
              this.enginner_job_seeking = res.data.user.job_seeking_situation;
              this.engineer_past_job_details = res.data.user.past_job_details;
              this.engineer_current_type_of_contract =
                res.data.user.current_type_of_contract;
              if (res.data.user.required_position != null) {
                var required_position = res.data.user.required_position.sort(
                  function(a, b) {
                    return a.id - b.id;
                  }
                );
                this.engineer_required_position = required_position;
              }
              if (res.data.user.required_position != null) {
                var requried_type_of_contract = res.data.user.required_type_of_contract.sort(
                  function(a, b) {
                    return a.id - b.id;
                  }
                );
                this.engineer_requried_type_of_contract = requried_type_of_contract;
              }
              if (res.data.user.languages) {
                var languages = res.data.user.languages.sort(function(a, b) {
                  return a.id - b.id;
                });
                this.engineer_languages = languages;
              }
              if (res.data.user.required_work_area_to_be != null) {
                var required_work_area_to_be = res.data.user.required_work_area_to_be.sort(
                  function(a, b) {
                    return a.id - b.id;
                  }
                );
                this.engineer_required_work_area_to_be = required_work_area_to_be;
              }
              this.engineer_role_to_handle = res.data.user.role_to_handle;
              var user = JSON.parse(localStorage.user)
              user.test_user = res.data.user.test_user
              user.completed_interview = res.data.user.completed_interview
              localStorage.setItem("user",JSON.stringify(user));
              this.profileLoaded = true;
              this.loading = false;
            } catch (error) {}

            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }
    },
    pressed_slide(id) {
      this.panelid = id;
      $(".wrapper1").removeClass("spressed");
      $("#s" + id).addClass("spressed");
      if (this.panelid === 1) {
        $("#basic_info").css("display", "flex");
        $("#score_info").css("display", "none");
      }
      if (this.panelid === 2) {
        $("#score_info").css("display", "block");
        $("#basic_info").css("display", "none");
        this.doCenter();
      }
    },
    pressed_slide_skill(id) {
      this.skillPanelid = id;
      $(".wrapper2").removeClass("spressed");
      $("#p" + id).addClass("spressed");
      if (this.skillPanelid === 1) {
        $("#technical_info").css("display", "block");
        $("#management_info").css("display", "none");
        this.getScore(this.skillPanelid);
      }
      if (this.skillPanelid === 2) {
        $("#management_info").css("display", "block");
        $("#technical_info").css("display", "none");
        this.getScore(this.skillPanelid);
        this.doCenter();
      }
    }
  }
};
</script>

<style scoped>
.resend-link{
  font-weight: 700;
  text-decoration: none;
}
.resend-link:hover{
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
.email-verify{
  color:red;
}
.jobDetailDesc{
  white-space:pre-wrap;
  text-align: justify;
   font-size: 1rem;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
   text-overflow: ellipsis;
   word-wrap: break-word;
  display: -webkit-box;

}
.jobDetail p{
  color: #b3b2ab;
  font-weight: 400 !important;
}
.jobDetail{
  background-color: #F2F2F2;
  padding: 10px 25px 10px 25px;
  margin-bottom: 20px;
  text-align: justify
}
.fb-signin-button {
  cursor: pointer;
  display: inline-block;
  padding: 16px;
  background-color: #4267b2;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  outline: none;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  white-space: nowrap;
  border-radius: 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
}
.fb-signin-button-disable {
  display: inline-block;
  padding: 16px;
  background-color: #4267b2;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  outline: none;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  white-space: nowrap;
  border-radius: 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px 0 rgba(49, 79, 147, 0.24),
    0 -2px 4px 0 rgba(49, 79, 147, 0.12);
}

.input input {
  font: inherit;
  width: 100%;
  padding: 6px 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.input.inline input {
  width: auto;
}

.input input:focus {
  outline: none;
  border: 1px solid #3d7dd8;
  background-color: #eee;
}

.input.invalid label {
  color: red;
}

.input.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}

.input select {
  border: 1px solid #ccc;
  font: inherit;
}

.slabel_panel {
  position: absolute;
  left: 56px;
}

.signin_label {
  font-size: 1.75rem;
  font-weight: bold;
}

.signin_label_jp {
  font-size: 1rem;
}

.ramsey {
  margin-top: 100px;
}

.signinpanel {
  padding: 0px 80px;
  padding-bottom: 60px;
}

.fa-facebook {
  float: left;
  font-size: 25px;
  margin-top: 2px;
  margin-left: 50px;
  font-weight: bold;
}

.fbsigntext {
  font-size: 1.125rem;
  margin-left: -50px;
  font-weight: bold;
}
svg:not(:root) {
  overflow: hidden;
  vertical-align: top;
}

.text-danger {
  background-color: #eeeeee;
}
.close {
  padding-right: 25px;
}
.addlinks {
  margin-top: 10px;
  background-color: #dae8ff;
  padding: 15px;
  border-radius: 30px;
}
.addlinks:hover {
  text-decoration: underline;
  cursor: pointer;
}
.nav-link {
  margin-right: -30px;
  margin-top: 15px;
}
.rounded-circle1 {
  border-radius: 100%;
}
.skillUpdate {
  padding-top: 10px;
  padding-bottom: 20px;
}

.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
  border: 2px solid #3d7dd8;
  font-size: 0.7rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #3d7dd8;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}

.sub-layer2 {
  width: fit-content;
  background-color: #3d7dd8;
  font-size: 0.7rem;
  text-align: center;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #fff;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 10px;
  border-radius: 50px;
  display: block;
}
.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
  word-wrap: break-word;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 35px;
  max-width: 200px;
}

.statustitle {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 34px;
  height: 50px;
  margin-bottom: 0.1rem;
}
.cline {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.statusnum {
  top: 55%;
  font-weight: bold;
  font-size: 3rem !important;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.custom-wrapper {
  max-height: 250px;
  overflow: auto;
}

@media screen and (max-width: 768px) {
  .pgraytxt {
    opacity: 0.64;
    font-size: 1rem;
    font-weight: 500;
    padding-left: 0px;
  }
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}
</style>
